import { AuthenticationService } from '../services/authentification.service';
import { catchError, firstValueFrom, map, of } from 'rxjs';

/** Bootstrap session au démarrage ; redirige vers le Launcher si non authentifié (hors stub). */
export function initializeAuth(authService: AuthenticationService) {
  return () =>
    firstValueFrom(
      authService.initializeSession().pipe(
        catchError(() => of(false)),
        map((authenticated) => {
          if (
            !authenticated &&
            !authService.isUserLoggedIn() &&
            !authService.isStubAuth()
          ) {
            authService.redirectToLauncherLogin(
              window.location.pathname + window.location.search
            );
          }
          return authenticated;
        })
      )
    );
}
